import { HashRouter as Router, Routes, Route } from "react-router-dom";
import { Container } from "react-bootstrap";
import Header from "./components/Header";
import Footer from "./components/Footer";
import HomeScreen from "./screens/HomeScreen";
import ShowScreen from "./screens/ShowScreen";
import TicketsScreen from "./screens/TicketsScreen";
import EventScreen from "./screens/EventScreen";
import LuncheonScreen from "./screens/LuncheonScreen";
import AwardsScreen from "./screens/AwardsScreen";
import CompanyScreen from "./screens/CompanyScreen";
import LoginScreen from "./screens/LoginScreen";
import RegisterScreen from "./screens/RegisterScreen";
import ProfileScreen from "./screens/ProfileScreen";
import UserListScreen from "./screens/UserListScreen";
import UserEditScreen from "./screens/UserEditScreen";
import AdminDashboardScreen from "./screens/AdminDashboardScreen";
import CartScreen from "./screens/CartScreen";
import { ThemePreviewProvider } from "./themePreview";

function AccountFrame({ children }) {
  return <Container className="py-4">{children}</Container>;
}

function App() {
  return (
    <Router>
      <ThemePreviewProvider>
      <Header />
      <main>
        <Routes>
          <Route path="/" element={<HomeScreen />} />
          <Route path="/show" element={<ShowScreen />} />
          <Route path="/tickets" element={<TicketsScreen />} />
          <Route path="/show/:id" element={<EventScreen />} />
          <Route path="/cart" element={<CartScreen />} />
          <Route path="/luncheon" element={<LuncheonScreen />} />
          <Route path="/awards" element={<AwardsScreen />} />
          <Route path="/company-information" element={<CompanyScreen />} />
          <Route path="/login" element={<LoginScreen />} />
          <Route path="/register" element={<RegisterScreen />} />
          <Route
            path="/profile"
            element={
              <AccountFrame>
                <ProfileScreen />
              </AccountFrame>
            }
          />
          <Route
            path="/admin/dashboard"
            element={
              <AccountFrame>
                <AdminDashboardScreen />
              </AccountFrame>
            }
          />
          <Route
            path="/admin/userList"
            element={
              <AccountFrame>
                <UserListScreen />
              </AccountFrame>
            }
          />
          <Route
            path="/admin/user/:id/edit"
            element={
              <AccountFrame>
                <UserEditScreen />
              </AccountFrame>
            }
          />
        </Routes>
      </main>
      <Footer />
      </ThemePreviewProvider>
    </Router>
  );
}

export default App;
